const UserIcon = ({ classname, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
    >
      <path
        d="M11.7501 1.25C8.85063 1.25 6.50012 3.6005 6.50012 6.5C6.50012 9.39949 8.85063 11.75 11.7501 11.75C14.6496 11.75 17.0001 9.39949 17.0001 6.5C17.0001 3.6005 14.6496 1.25 11.7501 1.25Z"
        fill={fill || "#888888"}
      />
      <path
        d="M17.975 15.0771C17.814 14.9862 17.6717 14.9059 17.5563 14.8372C14.0022 12.7209 9.4981 12.7209 5.94405 14.8372C5.82774 14.9064 5.68405 14.9875 5.52139 15.0793C4.80858 15.4814 3.73107 16.0893 2.9929 16.8118C2.53123 17.2637 2.09258 17.8592 2.01283 18.5888C1.92803 19.3646 2.26649 20.0927 2.94551 20.7396C4.11696 21.8556 5.52274 22.75 7.34105 22.75H16.1593C17.9776 22.75 19.3834 21.8556 20.5548 20.7396C21.2338 20.0927 21.5723 19.3646 21.4875 18.5888C21.4077 17.8592 20.9691 17.2637 20.5074 16.8118C19.7692 16.0893 18.6917 15.4814 17.9789 15.0793L17.975 15.0771Z"
        fill={fill || "#888888"}
      />
    </svg>
  );
};

export default UserIcon;
